<template>
  <div class="container">
    <pre style="display: none">{{ pagination | pretty_json }}}</pre>
    <h1>Lista de Fontes</h1>
    <div class="card">
      <div class="card-body">
        <div class="d-flex">
          <div class="p-2 flex-grow-1"></div>
          <div class="p-2">
            <router-link
              v-if="$can('source:create')"
              :to="{
                name: 'source_create'
              }"
              class="btn btn-outline-primary ml-auto link-edit"
            >
              Novo
              <b-icon
                icon="plus-circle"
                aria-hidden="true"
                class="mx-auto my-auto pl-1"
              ></b-icon
            ></router-link>
          </div>
        </div>

        <b-table striped hover :items="sources" :fields="fields">         
          <template #cell(actions)="row">
            <Actions
              :item="row.item"
              :view_show="false"
              :view_edit="$can('source:edit')"
              :view_delete="$can('source:delete')"
              edit_to="source_edit"
              @delete="delete_source"
            />
          </template>
        </b-table>
      </div>
    </div>
    <div class="overflow-auto mt-4">
      <b-pagination-nav
        v-model="page"
        :link-gen="linkGen"
        :number-of-pages="pagination.last_page"
        use-router
      ></b-pagination-nav>
    </div>
  </div>
</template>

<script>
import Actions from "@/components/Table/Actions.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Actions },
  data() {
    return {
      page: 1
    };
  },
  computed: {
    ...mapState("source", ["sources", "pagination"]),
    fields() {
      return [
        { key: "id", label: "#" },
        { key: "name", label: "Nome" },      
        { key: "actions", label: "#" }
      ];
    }
  },
  methods: {
    ...mapActions("source", ["ActionGetAll", "ActionDelete"]),

    async delete_source(source) {
      try {
        await this.ActionDelete(source.id);
        this.$notifications.addNotification({
          message: "Registro deletado com sucesso",
          type: "success"
        });
        await this.ActionGetAll({});
      } catch (error) {
        console.log("error", error.data);
        this.$notifications.addNotification({
          message: "Erro ao excluir registro.<br/>" + error.data.message,
          type: "danger"
        });
      }
    },

    linkGen(pageNum) {
      return pageNum === 1 ? "?" : `?page=${pageNum}`;
    }
  },
  async created() {
    if (this.$route.query.page > 1) {
      this.page = this.$route.query.page;
    }
    await this.ActionGetAll({ page: this.page });
  }
};
</script>

<style></style>
